export const DEFAULT_REPLY_EMAIL = "abisiniyatravels@gmail.com";

export const nonEmpty = (v) => v !== null && v !== undefined && String(v).trim() !== "";

export function htmlEscape(s = "") {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function buildEmailHTML({ subject, bodyHtml, signature, replyToEmail }) {
  const content    = bodyHtml || "";
  const replyEmail = String(replyToEmail || DEFAULT_REPLY_EMAIL).trim();

  // Build the mailto href that will be injected into CTA buttons.
  // The send pipeline's swapCtaHref() will later replace this with a
  // tracked /track/cta/{token} URL so clicks are recorded.
  const mailSubject = `Re: ${subject || "Abisiniya Travel"}`;
  const mailBody    = `Hello,\n\nI am replying to your email regarding: ${subject || "your message"}\n\nThank you.`;
  const ctaMailto   = `mailto:${replyEmail}?subject=${encodeURIComponent(mailSubject)}&body=${encodeURIComponent(mailBody)}`;

  // Replace href="#" placeholders (from the WYSIWYG button builder) with the
  // reply mailto so clicking any CTA button opens the email client pre-filled.
  const processedContent = content.replace(
    /href\s*=\s*["']#["']/gi,
    `href="${htmlEscape(ctaMailto)}"`
  );

  // Signature block.
  // Only render an image signature when the URL is a full http(s) URL — a
  // relative/local URL would be a broken image in the recipient's email client.
  const sigBlock = (() => {
    if (!signature?.enabled) return "";

    if (signature.imageUrl && /^https?:\/\//i.test(String(signature.imageUrl))) {
      return `
    <div data-signature-marker="1" style="margin-top:24px;padding-top:16px;border-top:2px solid #2db838;">
      <img src="${htmlEscape(signature.imageUrl)}"
           alt="Signature"
           style="display:block;max-width:320px;height:auto;border:none;" />
    </div>`;
    }

    if (signature.senderName || signature.title || signature.phone || signature.website || signature.address) {
      return `
    <div data-signature-marker="1" style="margin-top:24px;border-top:2px solid #2db838;padding-top:16px;font-size:14px;color:#4b5563;line-height:1.6;font-family:Arial,sans-serif;">
      <strong style="font-size:15px;color:#111;">${htmlEscape(signature.senderName || "")}</strong><br/>
      ${signature.title ? `<span style="color:#555;">${htmlEscape(signature.title)}</span><br/>` : ""}
      ${signature.phone ? `${htmlEscape(signature.phone)}<br/>` : ""}
      ${signature.email ? `<a href="mailto:${htmlEscape(signature.email)}" style="color:#2db838;text-decoration:none;">${htmlEscape(signature.email)}</a><br/>` : ""}
      ${signature.website ? `<a href="${htmlEscape(signature.website)}" target="_blank" rel="noopener noreferrer" style="color:#2db838;text-decoration:none;">${htmlEscape(signature.website)}</a><br/>` : ""}
      ${signature.address ? `<span style="color:#777;">${htmlEscape(signature.address)}</span>` : ""}
    </div>`;
    }

    return "";
  })();

  return `
<!doctype html>
<html>
<head>
<meta name="viewport" content="width=device-width,initial-scale=1"/>
<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
<title>${htmlEscape(subject)}</title>
</head>
<body style="margin:0;background:#ffffff;font-family:Inter,Segoe UI,Arial,sans-serif">
  <div style="padding:20px; max-width:600px; margin:0 auto;">
    ${subject ? `<div data-subject-heading="1" style="margin:0 0 20px 0;padding-bottom:12px;border-bottom:2px solid #2db838;font-size:22px;line-height:1.35;font-weight:bold;color:#111827;">${htmlEscape(subject)}</div>` : ""}
    <div style="font-size:16px;color:#111827;line-height:1.6;">
      ${processedContent}
    </div>

    ${sigBlock}
  </div>
</body>
</html>`;
}
